export const RiskProfileEnum = {
  1: 'conservative',
  2: 'moderate',
  3: 'dynamic',
};
